import { CURRENCY_CODE_PLACEHOLDER, VALUE_PLACEHOLDER, currencyFormatConfig, defaultCurrencyFormatConfig, getCurrencyFormat, } from './currency-format-config';
import { getMoney } from './utils';
export const isWholeNumber = (value) => Math.floor(value) === value;
export const getCurrencyFormatConfig = (currencyCode) => 
// @ts-expect-error
currencyFormatConfig[currencyCode] || defaultCurrencyFormatConfig;
export const getFormattedPriceValue = (value, currencyCode) => {
    const config = getCurrencyFormatConfig(currencyCode);
    return value.toFixed(!isWholeNumber(value) ? config.decimalDigits : 0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
/** @deprecated use priceFormatter */
export const getFormattedPrice = (value, currencyCode) => {
    const config = getCurrencyFormatConfig(currencyCode);
    return getCurrencyFormat(config)
        .replace(VALUE_PLACEHOLDER, getFormattedPriceValue(value, currencyCode))
        .replace(CURRENCY_CODE_PLACEHOLDER, currencyCode);
};
export const getFormattedMultiplePrices = (definition, priceFormatter = getFormattedMoney, separator = '-') => {
    var _a, _b;
    const options = (_b = (_a = definition === null || definition === void 0 ? void 0 : definition.pricing) === null || _a === void 0 ? void 0 : _a.pricingOptions) === null || _b === void 0 ? void 0 : _b.options;
    if (options === null || options === void 0 ? void 0 : options.length) {
        const currency = options[0].price.currency;
        const priceAmounts = options.map(option => Number(option.price.amount));
        const minPriceAmount = Math.min(...priceAmounts);
        const maxPriceAmount = Math.max(...priceAmounts);
        const formattedMinPriceAmount = priceFormatter(getMoney(minPriceAmount, currency));
        const formattedMaxPriceAmount = priceFormatter(getMoney(maxPriceAmount, currency));
        if (minPriceAmount === maxPriceAmount) {
            return formattedMinPriceAmount;
        }
        else {
            return `${formattedMinPriceAmount}${separator}${formattedMaxPriceAmount}`;
        }
    }
    else {
        return undefined;
    }
};
/** @deprecated use priceFormatter */
export const getFormattedMoney = (money) => { var _a; return getFormattedPrice(Number((_a = money.amount) !== null && _a !== void 0 ? _a : 0), money.currency); };
export const getFormattedDiscount = (discount) => isWholeNumber(discount) ? Math.trunc(discount) : discount;
export const getCurrencySymbol = (currencyCode) => {
    const config = getCurrencyFormatConfig(currencyCode);
    return config.symbol || currencyCode;
};
export const isCurrencySuffixed = (currencyCode) => {
    const config = getCurrencyFormatConfig(currencyCode);
    return config.suffix || false;
};
//# sourceMappingURL=formatter.js.map